import { z } from 'zod';
import {
    ModelCodeCreateForm,
    // ModelCodeUpdateForm,
    ModelCodeCreateFormErrors,
    ModelCodeCreateFormErrorsSchema,
    // ModelCodeUpdateFormErrors,
    // ModelCodeUpdateFormErrorsSchema,
} from '@/types/model-code.type.ts';
import { ModelStatus } from '@/types/model/model-status.type.ts';

export type ModelUpdateForm = {
    brand_id: number,
    name: string,
    symbolic_code: string,
    status: ModelStatus,
    new_model_codes: ModelCodeCreateForm[],
    // updated_model_codes: ModelCodeUpdateForm[],
    deleted_model_codes: number[],
};

export type ModelUpdateFormErrors = {
    brand_id?: string[],
    name?: string[],
    symbolic_code?: string[],
    status?: string[],
    model_codes?: (ModelCodeCreateFormErrors | undefined)[],
    new_model_codes?: (ModelCodeCreateFormErrors | undefined)[],
    // updated_model_codes?: ModelCodeUpdateFormErrors[],
    deleted_model_codes?: string[],
};

export const ModelUpdateFormErrorsSchema = z.object({
    brand_id: z.array(z.string()).optional(),
    name: z.array(z.string()).optional(),
    symbolic_code: z.array(z.string()).optional(),
    status: z.array(z.string()).optional(),
    model_codes: z.array(ModelCodeCreateFormErrorsSchema.optional()).optional(),
    new_model_codes: z.array(ModelCodeCreateFormErrorsSchema.optional()).optional(),
    // updated_model_codes: z.array(ModelCodeUpdateFormErrorsSchema).optional(),
    deleted_model_codes: z.array(z.string()).optional(),
});
